<div class="p-5">

  <!-- Header -->
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon class="text-aguacate-green mr-2">account_balance</mat-icon>
        Transacciones retiro FIAT pendientes
        <span *ngIf="totalItems"
          class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
          {{ totalItems }} registros
        </span>
      </h1>
      <span *ngIf="totalItems"
        class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
        {{ totalItems }} registros
      </span>
    </div>
    <div class="mt-3 md:mt-0">
      <button type="button" (click)="openShinkansenMontoMaxModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #1C593D; border: 1px solid #1C593D; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">tune</mat-icon>
        Monto máximo automático Shinkansen
      </button>
    </div>
  </div>

  <!-- C1: falló la carga de retiros VES pendientes; las FIAT_VES_CLP no se pueden rechazar -->
  <div *ngIf="errorCardexVes" role="alert" data-test="error-cardex-ves"
    class="flex flex-col sm:flex-row sm:items-center gap-3 mb-6 p-4 rounded-xl border border-amber-200 bg-amber-50 text-amber-900">
    <div class="flex items-start gap-3 flex-1 min-w-0">
      <mat-icon class="text-amber-600 shrink-0">warning</mat-icon>
      <div class="text-sm min-w-0">
        <p class="font-semibold m-0">No se pudo obtener los retiros VES pendientes.</p>
        <p class="m-0">Los retiros VES→CLP no se pueden rechazar. Recarga e intenta de nuevo.</p>
      </div>
    </div>
    <button type="button" (click)="loadTransactions()"
      class="w-full sm:w-auto inline-flex items-center justify-center gap-1 px-4 py-2 rounded-lg border border-amber-300 bg-white text-amber-900 text-sm font-semibold cursor-pointer">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">refresh</mat-icon>
      Recargar
    </button>
  </div>

  <!-- Filtros -->
  <div class="flex justify-center mb-6">
    <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">
      <div class="text-center mb-4">
        <h3 class="text-lg font-semibold text-gray-700 flex items-center justify-center">
          <mat-icon class="text-aguacate-green mr-2">filter_list</mat-icon>
          Filtros de Búsqueda
        </h3>
      </div>
      <div class="flex justify-center">
        <mat-form-field appearance="outline" class="w-full max-w-md modern-field">
          <mat-label>Buscar</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">search</mat-icon>
          <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtrar datos...">
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- ═══ Tabla Desktop ═══ -->
  <div class="hidden lg:block overflow-auto border rounded-lg shadow-md bg-white max-h-[65vh]" *ngIf="dataSource && dataSource.data.length > 0">
    <table mat-table [dataSource]="dataSource" class="w-full table-responsive">

      <!-- ID -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">ID</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs font-bold font-mono">
            {{ row.id }}
          </span>
        </td>
      </ng-container>

      <!-- Fecha Creación -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Fecha</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.createdAt | date:'dd/MM/yy HH:mm' }}
        </td>
      </ng-container>

      <!-- ClienteID -->
      <ng-container matColumnDef="idUser">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">ClienteID</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono font-bold">
          {{ row.userId }}
        </td>
      </ng-container>

      <!-- Nombre Usuario -->
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">Nombre</th>
        <td mat-cell *matCellDef="let row" class="text-left p-2 text-xs font-medium">
          {{ row.nombreUsuario }} {{ row.apellidosUsuario }}
        </td>
      </ng-container>

      <!-- Ruta -->
      <ng-container matColumnDef="ruta">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Ruta</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-medium">
          <span class="px-2 py-0.5 rounded-full text-xs font-semibold"
            [ngClass]="row.tipoTransaccion === 'FIAT_VES_CLP' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'">
            {{ row.paisOrigen || '?' }} → {{ row.paisDestino || '?' }}
          </span>
        </td>
      </ng-container>

      <!-- Alias Cuenta Retiro -->
      <ng-container matColumnDef="cuentaRetiroId">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Alias</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.alias }}
        </td>
      </ng-container>

      <!-- Monto Retiro -->
      <ng-container matColumnDef="valorRetiro">
        <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">Monto</th>
        <td mat-cell *matCellDef="let row" class="text-right p-2 text-xs font-bold text-green-600">
          {{ row.totalMonedaDestino | currency:'$' }}
        </td>
      </ng-container>

      <!-- Banco Destino -->
      <ng-container matColumnDef="bancoDestino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Banco</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.bancoNombre }}
        </td>
      </ng-container>

      <!-- Cuenta Destino -->
      <ng-container matColumnDef="cuentaDestino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Cuenta</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono">
          {{ row.tipoCuentaNombre }} {{ row.numeroCuenta }}
        </td>
      </ng-container>

      <!-- Identificación -->
      <ng-container matColumnDef="identificacion">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Identificación</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono">
          {{ row.tipoIdentificacion }} {{ row.numeroId }}
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Acciones</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <!-- Payout status badge -->
          <div *ngIf="getPayoutStatusBadge(row)" class="mb-1 text-center">
            <span [ngClass]="{
              'bg-green-100 text-green-800': getPayoutStatusBadge(row)?.class === 'badge-success',
              'bg-yellow-100 text-yellow-800': getPayoutStatusBadge(row)?.class === 'badge-warning',
              'bg-red-100 text-red-800': getPayoutStatusBadge(row)?.class === 'badge-error',
              'bg-blue-100 text-blue-800': getPayoutStatusBadge(row)?.class === 'badge-info',
              'bg-gray-100 text-gray-800': getPayoutStatusBadge(row)?.class === 'badge-default'
            }" class="text-xs px-2 py-0.5 rounded-full font-semibold whitespace-nowrap"
              [title]="getPayoutErrorTooltip(row)">
              {{ getPayoutStatusBadge(row)?.icon }} {{ getPayoutStatusBadge(row)?.text }}
            </span>
            <div *ngIf="getPayoutErrorDisplay(row) as motivo"
              class="text-xs text-red-700 mt-1 max-w-[180px] mx-auto"
              style="line-height: 1.2; word-break: break-word;"
              [title]="getPayoutErrorTooltip(row)">
              <strong *ngIf="row.shinkansenPayout?.errorCode" class="block uppercase text-[0.6rem] tracking-wide text-red-600">
                {{ row.shinkansenPayout.errorCode }}
              </strong>
              <span class="block">{{ motivo }}</span>
            </div>
          </div>

          <div class="flex gap-1 justify-center flex-wrap">
            <button title="Copiar" (click)="copyData(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">content_copy</mat-icon>
            </button>
            <button *ngIf="canProcessManually(row)" title="Pagar" (click)="openSendTransactionModal(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">done</mat-icon>
            </button>
            <button *ngIf="canPayWithShinkansen(row)" title="Pagar Shinkansen" (click)="openPayShinkansenModal(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fde68a; border-radius: 6px; background: #fffbeb; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #f59e0b;">attach_money</mat-icon>
            </button>
            <button title="Editar" (click)="openEditTrxModal(row)"
              [disabled]="row.shinkansenPayout?.status === 'pending'"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;"
              [style.opacity]="row.shinkansenPayout?.status === 'pending' ? '0.4' : '1'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
            </button>
            <button title="Rechazar" (click)="openRejectTransactionModal(row)"
              [disabled]="isRejectBlocked(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;"
              [style.opacity]="isRejectBlocked(row) ? '0.4' : '1'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">close</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- ═══ Mobile / Tablet Cards (Acordeón) ═══ -->
  <div class="lg:hidden">
    <div *ngIf="!dataSource || dataSource.data.length === 0"
      style="text-align: center; padding: 40px 20px;">
      <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">account_balance</mat-icon>
      <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron transacciones</p>
    </div>

    <div *ngFor="let row of dataSource?.data"
      style="border: 1px solid #e5e7eb; border-radius: 10px; overflow: hidden; margin-bottom: 8px;"
      [style.border-color]="expandedCardId === row.id ? '#1C593D' : '#e5e7eb'">

      <!-- Card header -->
      <div (click)="toggleCard(row.id)"
        style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; cursor: pointer; user-select: none;"
        [style.background]="expandedCardId === row.id ? '#f0fdf4' : '#f9fafb'">

        <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap; flex: 1; min-width: 0;">
          <span style="background: #dcfce7; color: #1e5a3f; font-size: 0.7rem; padding: 2px 7px; border-radius: 10px; font-weight: 600;">
            #{{ row.id }}
          </span>
          <!-- Payout badge -->
          <span *ngIf="getPayoutStatusBadge(row)"
            [ngClass]="{
              'bg-green-100 text-green-800': getPayoutStatusBadge(row)?.class === 'badge-success',
              'bg-yellow-100 text-yellow-800': getPayoutStatusBadge(row)?.class === 'badge-warning',
              'bg-red-100 text-red-800': getPayoutStatusBadge(row)?.class === 'badge-error',
              'bg-blue-100 text-blue-800': getPayoutStatusBadge(row)?.class === 'badge-info',
              'bg-gray-100 text-gray-800': getPayoutStatusBadge(row)?.class === 'badge-default'
            }"
            style="font-size: 0.6rem; padding: 2px 6px; border-radius: 10px; font-weight: 600;"
            [title]="getPayoutErrorTooltip(row)">
            {{ getPayoutStatusBadge(row)?.icon }} {{ getPayoutStatusBadge(row)?.text }}
          </span>
          <span *ngIf="getPayoutErrorDisplay(row) as motivo"
            class="text-red-700"
            style="font-size: 0.6rem; padding: 2px 6px; line-height: 1.2; max-width: 180px; word-break: break-word;"
            [title]="getPayoutErrorTooltip(row)">
            {{ row.shinkansenPayout?.errorCode ? row.shinkansenPayout.errorCode + ': ' : '' }}{{ motivo }}
          </span>
          <span style="font-size: 0.7rem; color: #374151; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ row.nombreUsuario }} {{ row.apellidosUsuario }}
          </span>
          <span style="font-size: 0.7rem; color: #1e5a3f; font-weight: 700; white-space: nowrap;">
            {{ row.totalMonedaDestino | currency:'$' }}
          </span>
        </div>

        <mat-icon style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease; flex-shrink: 0; margin-left: 4px;"
          [style.transform]="expandedCardId === row.id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Card body -->
      <div *ngIf="expandedCardId === row.id">
        <div style="padding: 12px 16px; background: white;">
          <div class="grid grid-cols-2 gap-x-12 gap-y-1">

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">ID</span>
              <span style="color: #111827; font-weight: 700; font-size: 0.85rem; font-family: monospace;">
                {{ row.id }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.createdAt | date:'dd/MM/yy HH:mm' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">ClienteID</span>
              <span style="color: #111827; font-weight: 700; font-size: 0.85rem; font-family: monospace;">
                {{ row.userId }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Ruta</span>
              <span style="font-size: 0.85rem; font-weight: 600; padding: 1px 8px; border-radius: 10px;"
                [ngClass]="row.tipoTransaccion === 'FIAT_VES_CLP' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'">
                {{ row.paisOrigen || '?' }} → {{ row.paisDestino || '?' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Alias</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.alias }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Nombre</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.nombreUsuario }} {{ row.apellidosUsuario }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto</span>
              <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem;">
                {{ row.totalMonedaDestino | currency:'$' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.bancoNombre }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Cuenta</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">
                {{ row.tipoCuentaNombre }} {{ row.numeroCuenta }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Identificación</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">
                {{ row.tipoIdentificacion }} {{ row.numeroId }}
              </span>
            </div>

          </div>
        </div>

        <!-- Action buttons -->
        <div style="display: flex; gap: 6px; padding: 10px 16px; background: #f9fafb; border-top: 1px solid #f3f4f6; flex-wrap: wrap;">
          <button (click)="copyData(row)"
            style="display: flex; align-items: center; gap: 4px; padding: 8px 12px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">content_copy</mat-icon>
            Copiar
          </button>
          <button *ngIf="canProcessManually(row)" (click)="openSendTransactionModal(row)"
            style="display: flex; align-items: center; gap: 4px; padding: 8px 12px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">done</mat-icon>
            Pagar
          </button>
          <button *ngIf="canPayWithShinkansen(row)" (click)="openPayShinkansenModal(row)"
            style="display: flex; align-items: center; gap: 4px; padding: 8px 12px; background: #f59e0b; color: white; border: none; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">attach_money</mat-icon>
            Shinkansen
          </button>
          <button (click)="openEditTrxModal(row)"
            [disabled]="row.shinkansenPayout?.status === 'pending'"
            style="display: flex; align-items: center; gap: 4px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: none; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer;"
            [style.opacity]="row.shinkansenPayout?.status === 'pending' ? '0.5' : '1'">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">edit</mat-icon>
            Editar
          </button>
          <button (click)="openRejectTransactionModal(row)"
            [disabled]="isRejectBlocked(row)"
            style="display: flex; align-items: center; gap: 4px; padding: 8px 12px; background: #fee2e2; color: #dc2626; border: none; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer;"
            [style.opacity]="isRejectBlocked(row) ? '0.5' : '1'">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">close</mat-icon>
            Rechazar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state desktop -->
  <div *ngIf="!dataSource || dataSource.data.length === 0"
    class="hidden lg:block"
    style="text-align: center; padding: 40px 20px; background: white; border-radius: 12px; border: 1px solid #e5e7eb; margin-top: 8px;">
    <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">search_off</mat-icon>
    <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron transacciones pendientes.</p>
  </div>

  <!-- Paginador -->
  <div *ngIf="dataSource && dataSource.data.length > 0" class="mt-2">
    <mat-paginator #paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [pageIndex]="currentPage - 1"
      aria-label="Select page"
      (page)="onPageChange($event)"
      style="border-radius: 0 0 12px 12px; border: 1px solid #e5e7eb; border-top: none;">
    </mat-paginator>
  </div>

</div>
